import { ROUTES } from 'base/routes/routes'
import { Route, Routes } from 'react-router-dom'


export const exchangeRewardsRoutes = ({
  ListGifts,
  CreateGift,
  UpdateGift,
  ManageExchangeRewards,
  CreateManage,
  UpdateManage,
  Reward,

}: {
  ListGifts: React.ComponentType,
  ManageExchangeRewards: React.ComponentType
  Reward: React.ComponentType
  CreateManage: React.ComponentType
  UpdateManage: React.ComponentType
  CreateGift: React.ComponentType
  UpdateGift: React.ComponentType

}) => {
  return <Routes>
    {/* ------  -------------- --------- DANH SÁCH QUÀ TẶNG ------------- -------------- ------------------- */}
    <Route path={ROUTES.EXCHANGE_REWARDS.GIFTS.BASE} element={<ListGifts />} />
    <Route path={ROUTES.EXCHANGE_REWARDS.GIFTS.CREATE.BASE} element={<CreateGift />} />
    <Route path={ROUTES.EXCHANGE_REWARDS.GIFTS.DETAIL} element={<UpdateGift />} />
    {/* ------  -------------- --------- QUẢN LÍ ĐỔI THƯỞNG ------------- -------------- ------------------- */}
    <Route path={ROUTES.EXCHANGE_REWARDS.MANAGE.BASE} element={<ManageExchangeRewards />} />
    <Route path={ROUTES.EXCHANGE_REWARDS.MANAGE.CREATE.BASE} element={<CreateManage />} />
    <Route path={ROUTES.EXCHANGE_REWARDS.MANAGE.DETAIL} element={<UpdateManage />} />

    <Route path={ROUTES.EXCHANGE_REWARDS.MANAGE.CREATE.REWARD.BASE} element={<Reward />} />
  </Routes>
}